// extracted by mini-css-extract-plugin
module.exports = {"main":"Permissions_main__2Yk70","optionDiv":"Permissions_optionDiv__pQBfc","table":"Permissions_table__1HwsE","nameField":"Permissions_nameField__2RE7v"};